const Spanish = {
  Build: "Construye",
  Hero_text: "tu currículum de",
  record_time: "manera ágil y eficiente.",
  hero_sub_text:
    "Destácate en el mercado laboral y acelera tu proceso de contratación con la ayuda de inteligencia artificial",
  Generate_cv: "Generar Currículum",
  Signup: "Registrarse",
  Unlock:
    "Desbloquea la Búsqueda de Talento Potenciada por la Inteligencia Artificial",
  Discover: "Descubre profesionales expertos listos para causar un impacto.",
  Did: "¿Sabías que el 70% de los trabajadores de cuello azul no tienen currículum?",
  dont: "No Tengo Currículums?",
  Did_subText:
    "Distingáse de la competencia creando un currículum profesional hoy. ¡Comience ahora y desbloquee nuevas oportunidades profesionales!",
  Get_Started: "Empezar",
  Coming_soon: "¡Próximamente!",
  Marching_tool:
    "Herramienta de coincidencia de trabajo y talento impulsada por IA",
  Coming_soon_sub_text:
    "Acorta la brecha entre trabajadores y empresas con nuestra plataforma perfectamente integrada. Descubre opciones de trabajo flexibles que se adapten a tu horario. Únete a nuestra red de individuos talentosos y desbloquea emocionantes oportunidades.",
  Hire_Talent: "¡Contrata talentos también",
  Select_resume:
    "Elige tu diseño favorito y crea tu currículum profesional sin esfuerzo. Nuestra plataforma lo hace rápido y conveniente para que puedas mostrar tus habilidades y experiencias de manera efectiva.",
  Generate: "Generar.",
  coat_1:
    "¡Moil está revolucionando la industria de la comida rápida! Me ayudó a mostrar mis habilidades y conseguir puestos mejor remunerados. ¡Gracias a Moil, he llevado mi carrera al siguiente nivel!",
  coat_2:
    "Como trabajador de la construcción, Moil comprende mis desafíos y me conecta con clientes que valoran mi arduo trabajo. Es la plataforma principal para profesionales de la construcción.",
  coat_3:
    "En la industria de la limpieza, Moil ha dado el reconocimiento que mis habilidades merecen. Los trabajos que he conseguido a través de Moil han sido gratificantes económicamente y me han ayudado a construir una sólida reputación. ¡Dale una oportunidad a Moil!",
  Subscribe: "Suscríbete y obtén ofertas y promociones exclusivas.",
  form_enter_your_mail: "Ingrese su correo electrónico",
  Subscribe_btn: "Suscribirse.",
  Company: "Compañía",
  About: "Acerca de",
  Careers: "Empleo",
  Logistic: "Logística",
  Privacy_Policy: "Privacidad y Política",
  Contacts: "Contactos",
  Help_FAQ: "Ayuda/Preguntas frecuentes",
  Press: "Prensa",
  Affilates: "Afiliados",
  More: "Más",
  Press_Centre: "Centro de Prensa",
  Our_Blog: "Nuestro Blog",
  Low_fare_tips: "Consejos para tarifas bajas",
  Copy_write: "Derechos de autor, Trabook 2022. Todos los derechos reservados.",
  Terms_condition: "Términos y Condiciones",
  Careers: "Carreras",
  Translate: "Traducir",
  Discover: "Descubrir",
  extract: "Extrayendo el texto del CV, esto puede tomar unos minutos",

  Personal_info: "Información Personal",
  Education: "Educación",
  Work_Experience: "Experiencia Laboral",
  Skills: "Habilidades",
  Vol_Exp: "Experiencia como Voluntario/a",
  Award_Honor: "Premios y Honores",
  Ref: "Referencias",
  Submit: "Submit",

  register_text:
    "¡Regístrate ahora para desbloquear beneficios exclusivos y acceder a nuestra plataforma! ¡Es rápido, sencillo y gratuito!",
  LoginPage: "*",
  left_text: "Únete a nosotros, responde algunas preguntas y da el primer paso hacia tu carrera soñada creando un perfil/currículum.",
  Welcome_back: "¡Bienvenido de nuevo!",
  Enter_your_info: "Ingresa la información que proporcionaste al registrarte.",
  Email: "Correo electrónico",
  Password: "Contraseña",
  Confirm_pass: "Confirmar Contraseña",
  Remember_me: "Recuérdame",
  Forgot_pwd: "Contraseña olvidada",
  Acct_q: "¿No tienes una cuenta?",
  Already_acct: "¿Ya tienes una cuenta?",
  sign_up: "registrarse",
  Login: "Iniciar sesión.",
  or: "o",
  sign_with_l: "Iniciar sesión con LinkedIn",
  sign_with_g: "Iniciar sesión con Google",

  spanish_T: "Español",
  english_T: "English",
  Dashboard_page: "*",
  welcome_text: "No estás solo.",
  welcome_sub_text:
    "Recuerda que un excelente currículum crea una gran impresión. ¡Impresiona a tus reclutadores hoy mismo!",
  second_part_text:
    "Crear un Tablero Profesional para disfrutar de todos los beneficios completos de Moil.",

  Profile_page: "*",
  My_profile: "Mi Perfil",
  About: "Acerca de",
  Skill: "Habilidad",
  Info: "Info",
  Location: "Ubicación",
  Links: "Enlaces",
  Edit: "Editar",

  Logout_comp_text: "*",
  Logout_text: "¿Estás seguro/a de que deseas cerrar sesión?",
  Yes: "Sí",
  No: "No",
    
   your_res: "¡Tu currículum está listo para descargar!",
   refresh: "¡Actualiza la página para ver tu currículum!",
   cancel: "Cancelar",
   preview: "Vista previa",
 
    final_modal: "*",
    m_top_text: "Gracias por elegir ",
    m_btn: "Previsualiza tu perfil y currículum.",
  continue_btn: "Continuar",

  Warning_modal_text: "*",
  Warning_text:
    "Por favor, ten en cuenta que la Versión Beta permite la creación de hasta dos páginas de tu currículum vitae.",

  modal_ai:
    "Nuestra inteligencia artificial está creando una descripción de experiencia única para ti. ¡Un momento y estarás listo para brillar!...",
  modal_AI:
    "Nuestra herramienta de IA está generando un resumen estándar y profesional para ti. Por favor, espera un minuto...",

  Upload: "*",
  Upload_heading: "Subir Resumen",
  Upload_text:
    "Minimiza el tiempo de creación de tu currículum al importar uno existente!",
  Upload_btn_text: "Cargar",
  skip_btn_text: "Omitir este paso",

  toast: "*",
  toast_job: "Por favor ingrese el título del trabajo de experiencia",
  toast_des: "Brevemente describe tu actividad diaria",
  toast_exp: "Por favor proporciona una experiencia laboral",
  toast_skill: "Por favor proporciona una habilidad.",
  toast_lang: "Por favor selecciona un idioma",
  toast_interest: "Por favor proporciona un interés.",
  t_lang_format: "Se requiere el formato del idioma",
  t_lang_select: "Solo puedes seleccionar un idioma.",
  p_summary: "Se requiere un resumen profesional.",

  CV_template_text: "*",
  Back_to_dashboard: "Volver al Tablero de Control",
  select_text: "Seleccionar plantilla de currículum vitae",

  month_year: "Mes Año",
  Resume_form: "*",
  Submit: "Enviar",
  Hey_there:
    "Estamos súper emocionados de colaborar contigo en la creación de un currículum que te haga destacar. Olvídate del lenguaje de corbata y corbatín; cuéntanos tus habilidades y experiencias a tu estilo. ¡Del resto nos encargamos nosotros!",
  Resume_text: "Formulario de Captura de Texto del Currículum",
  your_name: "¿Cuál es tu nombre completo?",
  your_name_p: "nombre y apellido",
  your_email: "¿Cuál es tu correo electrónico completo?",
  your_email_p: "tu correo electrónico",
  your_address: "Tu dirección",
  your_address_p: "Dirección, ciudad, estado",
  your_phone_no: "¿Cuál es tu número de teléfono?",
  your_phone_no_p: "123 456 7890",
  your_job_title: "¿Cuál es el título del trabajo para el que estás aplicando?",
  your_job_title_p: "Titulo del trabajo",
  your_linkedin: "Perfil de Linkedin",
  your_website: "Tu sitio web",
  back_to_template: "Volver a las plantillas",
  next_btn: "Siguiente",

  Education: "Educación",
  your_school: "¿A dónde fuiste a la escuela?",
  your_school_p: "Ingresa tu escuela",
  your_degree: "¿Qué nivel de educación tienes?",
  n_school: "No hay clases",
  h_school: "Escuela secundaria",
  c_school: "Universidad",
  m_school: "Maestros",
  p_sch: "doctorado",
  s_sch: "alguna universidad",
  o_sch: "otra",
  your_course: "¿Qué curso estudiaste?",
  your_course_p: "Ingresar al curso",
  sch_start: "¿Cuándo empezaste la escuela?",
   Reset_pass: "Restablecer Contraseña",
   New_pass: "Ingresa una nueva contraseña y asegúrate de no olvidarla.",
   new_password: "Nueva Contraseña",
   confirm_pass: "Confirmar Nueva Contraseña",
   Ensure: "Por favor asegúrate de que tu contraseña y la confirmación de contraseña sean correctas.",
   reset: "Restablecer",
   head: "En este paso, selecciona tu plantilla favorita.",
  sch_end: "¿Cuándo terminaste la escuela",
  Add_btn: "Agregar Educación",
  back_btn: "atrás",
  wrk_exp: "Experiencia laboral",
  where_you_wrk: "¿En dónde has trabajado ",
  where_you_wrk_p: "Ingrese al lugar de trabajo",
  wrk_role: "¿Cuál era tu título de trabajo o rol ",
  wrk_start: "¿Cuándo empezaste y terminaste este trabajo ",
  start_btn: "Iniciar",
  End: "Fin",
  strt_btn_date: "Fecha de Inicio.",
  End_date: "Fecha de Finalización",
  description: "En tus propias palabras, cuéntame qué haces en tu día a día.",
  click_text:
    "Haz clic en el botón de abajo para estructurar tu experiencia con nuestra herramienta de IA.",
  cap_genetate_text: "GENERAR",
  add_exp: "Agregar Experiencia",
  skill: "Habilidad",
  select_skill:
    "¡Dale clic a esos cilindros abajo! Así podrás visualizar y editar tu experiencia!",
    select_skill_sm: "Selecciona de la lista de habilidades o escribe para agregar una nueva habilidad y termínala con una coma ',' y luego haz clic en agregar desde la lista desplegable",
  sk_tech:
    "¿Cuáles son algunas habilidades técnicas o específicas del trabajo que tienes",
  sk_personal:
    "¿Cuáles son algunas habilidades personales de las que te sientes orgulloso/a ",
  volun_text: "Experiencia de voluntariado",
  vol_org: "¿Cuál es el nombre de la organización ",
  vol_p: "Ingresa organización",
  vol_start: "¿Cuándo te uniste ",
  add_text: "Agregar",
  Award_Hon: "Premios y reconocimientos",
  awd_title: "¿Cuál fue el título del premio?",
  awd_t_p: "Ingrese el nombre del premio",
  awd_giver: "¿Quién te lo dio y por qué?",
  awd_time: "¿Cuándo lo recibiste?",
  awd_add_text: "Agregar Premio",
  Reference: "Referencia",
  ref_who: "¿A quién te gustaría poner como referencia?",
  ref_ans: "Ingresa nombre",
  ref_person: "¿Cómo conoces a esta persona?",
  ref_what: "¿Cuál es su título de trabajo y dónde trabajan?",
  ref_email: "Correo de referencia",
  ref_phone: "Número de teléfono de referencia",
  lang: "idioma",
  spk_lang: "¿Qué idiomas hablas?",
  spk_rate: "Tasa de habla del lenguaje",
  add_lang_btn: "Agregar idioma",
  Interests: "¿Otros intereses profesionales",
  int_p: "Separado por,",
  res_lang: "¿En qué idioma deseas que esté el currículum?",
  res_lang_p: "¿En qué idioma quieres que sea el currículum?",
  prof_sum: "¿Cómo describirías tu resumen profesional?",
  prof_gen_text:
    "Genere un resumen profesional al hacer clic en el botón debajo.",
  all_cv: "Descarga tu currículum y haz clic en este botón",
  done: "hecho",
  long_press: "Presiona el botón de abrir durante mucho tiempo y haz clic en ",
  download: "Enlace de descarga",
  cv: "descargar tu CV",

  your_res: "¡Tu currículum está listo para descargar!",
  refresh: "¡Actualiza la página para ver tu currículum!",
  cancel: "Cancelar",
  preview: "Vista previa",

  final_modal: "*",
  m_top_text: "Gracias por elegir ",
  m_btn: "Sigue para ver tu currículum.",

  Dashboard: "Tablero de control",
  Profile: "Perfil",
  My_resume: "Mi hoja de vida",
  Logout: "Cerrar sesión",
  Sub: "Subscribirse a Premium",

  Submit: "entregar",
  Hey_there:
    "¡Hola! Estamos emocionados de ayudarlo a crear un currículum increíble. No se preocupe por el lenguaje formal, solo cuéntenos sobre su experiencia y habilidades con sus propias palabras. ¡Nosotros nos encargamos del resto!",
  Resume_text: "Reanudar formulario de captura de texto",
  your_name: "Cuál es su nombre completo ?",
  your_name_p: "nombre y apellido",
  your_email: "Cual es tu email completo?",
  your_email_p: "Tu correo electrónico",

  text: "¡Dale clic a esos cilindros abajo! Así podrás visualizar y editar tu experiencia!",

  forget: "*",
  forget_pass: "¿Olvidaste tu Contraseña",
  mail_send:
    "Enviaremos el enlace para restablecer tu contraseña al correo proporcionado",
  Enter_mail: "Ingresa tu Correo Electrónico",
  p_email: "Por favor ingresa tu dirección de correo electrónico.",
  Back_to_login: "Volver al Inicio de Sesión",

  Reset_pass: "Restablecer Contraseña",
  New_pass: "Ingresa una nueva contraseña y asegúrate de no olvidarla.",
  new_password: "Nueva Contraseña",
  confirm_pass: "Confirmar Nueva Contraseña",
  Ensure:
    "Por favor asegúrate de que tu contraseña y la confirmación de contraseña sean correctas.",
  reset: "Restablecer",
  // BigSam
  // /generateCV
  back_button: "Atrás",
  note_beta_version:
    "Por favor, ten en cuenta que la Versión Beta permite la creación de hasta dos páginas de tu CV.",
  select_resume: "Seleccionar plantilla de currículum",

  //   form1
  resume_caph1: "Formulario de Captura de Texto del Currículum",
  heythere_form1:
    "Estamos súper emocionados de colaborar contigo en la creación de un currículum que te haga destacar. Olvídate del lenguaje de corbata y corbatín; cuéntanos tus habilidades y experiencias a tu estilo. ¡Del resto nos encargamos nosotros!",
  also_used: "¡Esto también se utilizará para crear tu perfil!",
  tab_1: "Información Personal",
  whatsname: "¿Cuál es tu primer nombre?",
  firstName: "Nombre aquí.",
  lastname: "Apellido aquí.",
  address_holder: "Dirección, ciudad, estado",
  email_here: "Dirección de correo electrónico aquí.",
  whats_lastname: "¿Cuál es tu apellido?",
  whats_address: "¿Cuál es tu dirección?",
  whats_email_address: "¿Cuál es tu dirección de correo electrónico?",
  whats_phone_number: "¿Cuál es tu número de teléfono?",
  whats_linkedin:
    "¿Tienes un perfil de LinkedIn o un sitio web personal? (Opcional)",
  linkedin_profile_link: "Perfil de LinkedIn",
  whats_website: "Tu Sitio Web",
  back_templates: "Volver a Plantillas",
  save_n_continue: "Guardar y Continuar",

  //   form2
  fillform_tab2:
    "Llena este formulario para informar a los empleadores acerca de tu educación.",
  usedfor_creating: "¡Esto también se utilizará para crear tu perfil!",
  education_tab2: "Educación.",
  where_school: "¿Dónde fuiste a la escuela?",
  education_level: "¿Qué nivel de educación tienes?",
  degree_gotten: "¿Qué título obtuviste?",
  start_studies: "¿Cuándo comenzaste tus estudios?",
  select_month_year: "Selecciona el mes y el año correspondiente.",
  finish_studies: "¿Cuándo terminaste tus estudios?",
  set_end_month: "Selecciona el mes y el año de finalización correspondientes.",
  special_recogn:
    "¿Recibiste algún reconocimiento especial o premios? (opcional)",
  have_added: "Has añadido",
  previous_btn: "Anterior",
  add_more: "Agregar más",
  view_less: "Ver menos",
  view_more: "Ver más",
  level_place: "Selecciona el nivel",
  enter_degree_p: "Ingresa tu título aquí",
  award_here_place: "Ingresar premio aquí",
  first_place: "Nombre de pila aquí",
  lastnaem_place: "Apellido aquí",
  fm2_dates: "Mes Año",

  //   form3
  work_experience: "Experiencia Laboral",
  where_work: "¿Dónde has trabajado?",
  what_job_title: "¿Cuál fue tu cargo o función?",
  when_start_end: "¿Cuándo empezaste y terminaste este trabajo?",
  select_start_end: "Selecciona el mes y el año de inicio correspondientes.",
  in_own_words: "En tus propias palabras, cuéntanos qué haces día a día.",
  generate_experience: "Generar Experiencia",
  workplace_place: "Escribe el nombre de tu lugar de trabajo aquí",
  title_place: "Ingresa tu título de trabajo aquí",

  //   form4
  skills_licencing: "Habilidades y Licencias",
  soft_proud:
    "¿Cuáles son algunas habilidades blandas de las que te sientes orgulloso/a?",
  certification_licence: "¿Tienes alguna certificación o licencia? (Opcional)",
  where_when_get: "¿Dónde y cuándo la obtuviste?",
  licence_place: "Nombre de la certificación/licencia",

  //   form5
  volunteer_experience: "Experiencia como Voluntario/a",
  voluteer_org: "¿En qué organización fuiste voluntario/a?",
  when_voluteer: "¿Cuándo fuiste voluntario/a?",
  ogarnization_place: "Ingresar organización aquí",
  month_place: "Mes",

  //   form6
  complete_award:
    "Completa esta página con cualquier premio que hayas recibido en el pasado. Si no tienes premios, haz clic en...",
  skip_quotes: "'Omitir esta página'",
  at_the_bottom: "en la parte inferior de la página.",
  awards_honors: "Premios y Honores",
  title_award: "Título del premio recibido",
  who_give_why: "¿Quién te lo dio?",
  when_recieve: "¿Cuándo lo recibiste?",
  skipstage_noquote: "Omitir esta etapa",
  award_place: "Título del premio",
  enter_place_name: "Ingresar nombre aquí",
  year_place: "Año",

  //   form7
  refrence: "Referencias",
  who_refrence: "¿A quién te gustaría incluir como referencia?",
  how_person: "¿Cómo conoces a esta persona?",
  who_them_be: "¿Cuál es su título de trabajo y dónde trabaja?",
  their_phone: "¿Cuál es su número de teléfono?",
  their_email: "¿Cuál es su dirección de correo electrónico?",
  fullname_place: "Ingresa su nombre completo aquí",
  answer_here_place: "Responder aquí",
  phone_here_place: "Número de teléfono aquí",

  //   form8
  lang_form8: "Idioma",
  first_lang: "¿¿Qué idioma hablas?",
  proficiency_level: "¿Cuál es tu nivel de competencia?",
  resume_lang: "¿En qué idioma deseas que sea el currículum?",
  proficiency_level_place: "Selecciona tu nivel de competencia",
  res_lang_place: "Idioma del currículum",
  lang_place: "Idioma",

  //   form9
  job_type: "Tipo de Trabajo",
  typejob_form9: "¿Qué tipo de trabajo estás buscando?",
  let_employer_know:
    "Informa a los empleadores sobre el tipo de trabajo para el que deseas ser contratado. Por ejemplo, fontanería, mesera, electricista.",
  update_job: "Actualizar título del trabajo",
  years_experience: "¿Cuántos años de experiencia tienes?",
  update_years: "Actualizar año de experiencia",
  other_pro_interst: "¿Otros intereses profesionales?",
  update_pi: "Update professional interest",
  pro_summary: "En tus propias palabras, describe tu resumen profesional.",
  describe_pro_sum:
    "¡Dale clic al botón de abajo y tendrás un resumen profesional que te hará destacar!.",
  do_you_want: "¿Quieres que se muestre tu título de trabajo en tu currículum?",
  save_n_preview: "Guardar y Vista Previa",
  years_experience_place: "Ingresa años de experiencia aquí",
  pro_exp_place: "Ingresa otros intereses profesionales",
  generate_sum: "Generar resumen",
};

export default Spanish;
